<template>
    <div v-if="plazos && plazos.length > 0 " class="table">
        <table :class="['table', { 'expanded': plazos.length <= 3 }, 'tabla-resumen']">
            <tr class="lightgray-content">
                <th class="text-center">Fecha cobro</th>
                <th class="text-center">Método de pago</th>
                <th class="text-center">Estado</th>
                <th class="text-center">Motivo del fallo</th>
                <th class="text-center">Descuento</th>
                <th class="text-center">Opciones</th>
                <th class="text-right pr-2 pr-xl-5">Total</th>
            </tr>
            <template v-for="(plazo, index) in plazos">
                <tr :key="index">
                    <td class="text-center">{{ plazo.fecha }}</td>
                    <td class="text-center">{{ plazo.metodo_pago }}</td>
                    <td class="text-center">
                        {{ plazo.estado_string }}
                    </td>
                    <td class="text-center">{{ plazo.motivo }}</td>
                    <td class="text-center">
                        {{ plazo.descuento_aplicado > 0 ? plazo.descuento_aplicado : 0 }} &euro;
                    </td>

                    <td class="text-center">
                        <OpcionesDropdownTableComponent
                            v-if="plazo.estado_string != 'PAGADO'"
                            :lastIndex="plazos.length > 3 && index >= plazos.length - 3"
                            :options="[
                                { type: 'action', action:() => showModal('pagar-plazo-' + plazo.id), label: 'Pagar' },
                                plazo.estado == 4 ? { type: 'action', action:() => showModal('enlace-pago-plazo-' + plazo.id), label: 'Generar enlace de pago' } : {},
                                plazo.descuento_aplicado == 0 ? { type: 'action', action:() => showModal('descuento-plazo-' + plazo.id), label: 'Aplicar descuento' } : {}
                            ]"
                        />
                        <GenerarEnlacePago :plazo="plazo" :params="params" :url="url_generar_enlace" @close="closeModal"/>
                        <PagarPlazo :plazo_id="plazo.id" :importe="plazo.importe" @close="closeModal" @terminado="pagarPlazo"/>
                        <DescuentoPlazo :plazo_id="plazo.id" :importe="plazo.importe" @close="closeModal" @terminado="descontar"/>
                    </td>

                    <td class="text-right pr-2 pr-xl-5">{{ plazo.importe | formatear_precio }}</td>
                </tr>
            </template>
            <tr class="text-right">
                <td colspan="7">
                    <h3>TOTAL: {{ importe_completo | formatear_precio }}</h3>
                    <div class="d-flex justify-content-end align-items-center" v-if="!data.plazos_pagados">
                        <h4 class="mt-1">Importe restante: {{ importe_restante | formatear_precio }}</h4>
                        <button class="btn btn-primary ml-2" @click="showModal('pagar-plazos')">Pagar</button>
                        <PagarPlazos :importe="importe_restante" @terminado="pagarPlazos"/>
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <div v-else>
        <h3>Este deportista no ha realizado el pago mediante plazos.</h3>
    </div>
</template>

<script>
    import PagarPlazo from './modals/PagarPlazo';
    import PagarPlazos from './modals/PagarPlazos';
    import DescuentoPlazo from './modals/DescuentoPlazo';
    import GenerarEnlacePago from './modals/GenerarEnlacePago';
    import OpcionesDropdownTableComponent from "../OpcionesDropdownTableComponent.vue";

    export default {
        props: ['plazos', 'data', 'params', 'url_generar_enlace'],
        computed: {
            importe_restante() {
                let total = 0;

                if (this.plazos) {
                    this.plazos.forEach(plazo => {
                        if (plazo.estado == 0 || plazo.estado == 5 || plazo.estado == 4) {
                            total = total + plazo.importe;
                        }
                    });
                }

                return total;
            },
            importe_completo() {
                let total = 0;

                if (this.plazos) {
                    this.plazos.forEach(plazo => {
                        total = total + plazo.importe;
                    });
                }

                return total;
            }
        },
        methods: {
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            pagarPlazo(metodo_pago, $plazo_id) {
                this.$emit('pagar-plazo', metodo_pago, $plazo_id);
            },
            pagarPlazos(metodo_pago) {
                this.$emit('pagar-plazos', metodo_pago);
            },
            descontar(descuento_integro, descuento_porcentaje, plazo_id) {
                this.$emit('descontar-plazo', descuento_integro, descuento_porcentaje, plazo_id);
            }
        },
        components: {
            OpcionesDropdownTableComponent,
            PagarPlazo, PagarPlazos, DescuentoPlazo,
            GenerarEnlacePago
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>